(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/chat/chat-ui/assets/javascripts/chat-admin-drawer.js') >= 0) return;  svs.modules.push('/components/chat/chat-ui/assets/javascripts/chat-admin-drawer.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const lbUiMockable = svs.components.lbUi;
const chatUiMockable = svs.components.chat.chatUi;
const Head = svs.components.chat.chatUi.Head;
const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  Button = _svs$ui.Button;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_LG = _svs$components$lbUti.BREAKPOINT_LG;
const _React = React,
  useState = _React.useState;
const ChatAdminDrawer = _ref => {
  let customerId = _ref.customerId,
    visible = _ref.visible,
    toggleChat = _ref.toggleChat,
    canEditUser = _ref.canEditUser,
    roomId = _ref.roomId,
    headline = _ref.headline,
    isEnabled = _ref.isEnabled,
    toggleStatus = _ref.toggleStatus,
    allowedToModerateChat = _ref.allowedToModerateChat,
    allowedToUnpublishChat = _ref.allowedToUnpublishChat,
    onShowDialog = _ref.onShowDialog;
  const _useState = useState('chat'),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  const isWideDevice = useMediaQuery(breakpoints.up(BREAKPOINT_LG));
  const getStyle = () => {
    const drawerStyle = {};
    if (isWideDevice && document.querySelector('.header')) {
      drawerStyle.marginTop = '';

      const header = document.querySelector('.header');
      const _header$getBoundingCl = header.getBoundingClientRect(),
        bottom = _header$getBoundingCl.bottom;
      drawerStyle.marginTop = bottom;
    }
    return drawerStyle;
  };
  const drawerStyle = getStyle();
  drawerStyle.maxWidth = 616;
  if (isWideDevice) {
    drawerStyle.zIndex = 1900;
  }
  const title = 'Vill du verkligen inaktivera kommentarsfältet?';
  const text = 'Kunderna kommer inte att kunna se och skriva kommentarer förrän kommentarsfältet aktiveras igen.';
  const buttons = [{
    text: 'Avbryt',
    classes: {
      inverted: true
    }
  }, {
    text: 'Inaktivera',
    classes: {
      focus: true
    },
    callback: () => {
      toggleStatus(roomId);
    }
  }];
  return React.createElement(lbUiMockable.Drawer, {
    className: "drawer-chat",
    direction: "right",
    isOpen: visible,
    isOverlayDisabled: true,
    onClickOverlay: toggleChat,
    style: drawerStyle
  }, React.createElement(chatUiMockable.ChatAdminContainer, {
    activeTab: activeTab,
    canEditUser: canEditUser,
    customerId: customerId,
    isEnabled: isEnabled,
    roomId: roomId
  }, React.createElement(Head, {
    headline: headline
  }, React.createElement("button", {
    "aria-label": "St\xE4ng chatten",
    className: "chat-head--btn qa-chat-close-btn icon-button",
    onClick: () => toggleChat(roomId),
    type: "button"
  }, React.createElement(ReactIcon, {
    color: "fc-grey-600",
    icon: "menu-right",
    size: "100"
  })), React.createElement("div", {
    className: "retail-chat-selector btn-group"
  }, React.createElement("button", {
    className: ['btn btn-100', activeTab === 'chat' ? 'btn-inverted' : 'btn-transparent-default', 'no-wrap margin-0 qa-retail-chat-comments padding'].join(' '),
    onClick: () => setActiveTab('chat'),
    type: "button"
  }, "Kommentarer"), React.createElement("button", {
    className: ['btn btn-100', activeTab === 'blocked' ? 'btn-inverted' : 'btn-transparent-default', 'no-wrap margin-0 qa-retail-chat-block-user padding'].join(' '),
    disabled: !allowedToModerateChat,
    onClick: () => setActiveTab('blocked'),
    type: "button"
  }, "Blockerade kunder")), React.createElement(Button, {
    className: "btn-icon btn-icon-right qa-retail-chat-disable",
    disabled: !allowedToUnpublishChat,
    onClick: () => isEnabled ? onShowDialog({
      title,
      text,
      buttons
    }) : toggleStatus(roomId),
    size: 100,
    transparent: true
  }, isEnabled ? 'Inaktivera' : 'Aktivera', React.createElement(ReactIcon, {
    icon: isEnabled ? 'eye-closed' : 'eye',
    size: "100"
  })))));
};
ChatAdminDrawer.defaultProps = {
  allowedToModerateChat: true,
  visible: false
};
setGlobal('svs.components.chat.chatUi.ChatAdminDrawer', ChatAdminDrawer);

 })(window);